/**
 * Import required libraries
 */
import React, { useState, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { project as projectApi } from "api"

/**
 * Import required elements
 */
import ProjectNavbarRender from "./render";

/**
 * ProjectNavbar Component
 */
function ProjectNavbar(props) {
  const [alert, openAlert] = useState(null);

  const history = useHistory();

  let { lang, projects, projectUid, openProjectUids, navigation, dispatch, colorButtonOnProjectBar } = props;

  const clickProject = useCallback((event, uid) => {
    event.stopPropagation();
    if (event) history.replace(`/project/${uid}`);
  }, [history])

  const confirmClose = useCallback((event, uid) => {
    openAlert(null)
    dispatch({ type: "CLOSE_PROJECT", uid });
    projectApi.close(uid)
    if (projectUid === uid) {
      const openProject = openProjectUids.filter(e => e !== uid).pop()
      if (openProject) {
        history.replace(`/project/${openProject}`);
      } else history.replace("/");
    }
  }, [history, openProjectUids, projectUid, dispatch])


  /**
   * 
   *  let { projectUid } = props;
    props.dispatch({
      type: "CLOSE_PROJECT",
      uid: projectUidToDelete
    });
    projectApi.close(projectUidToDelete)

    // console.log("Object.values(props.projects)", Object.values(props.projects))
    // let openProject = Object.values(props.projects)
    // .filter(p => p.uid !== projectUidToDelete)
    // .find(p => p.open === true);

    let openProjects = openProjectUids
      .filter(uid => uid !== projectUidToDelete)


    //Case close current
    if (projectUid === projectUidToDelete) {
      if (openProjects.length > 0) {
        history.push(`/project/${openProjects[0]}`);
      }
      else {
        history.push("/")
      }
    }
    else {
      if (openProjects.length > 0) {
        history.push(`/project/${projectUid}`);
      }
      else {
        history.push("/")
      }
    }
   */
  const cancelClose = useCallback((event) => {
    openAlert(null);
  }, [])

  const closeProject = useCallback((event, uid) => {
    event.stopPropagation();
    openAlert(uid);
  }, [])

  return React.createElement(ProjectNavbarRender, {
    lang,
    projects: useMemo(() => openProjectUids.reduce((acc, uid) => {
      if (projects && projects[uid]) {
        return [...acc, projects[uid]];
      } else return acc;
    }, []), [projects, openProjectUids]),
    projectUid,
    colorButtonOnProjectBar,
    navigation,
    clickProject,
    closeProject,
    alert,
    cancelClose,
    confirmClose
  });
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang,
  projects: state.list.project,
  projectUid: state.project.projectUid,
  openProjectUids: state.simtopy.openProjectUids,
  navigation: state.window.navigation,
  colorButtonOnProjectBar: state.simtopy.colorButtonOnProjectBar
}))(ProjectNavbar);
